import { render } from "./PlanC.vue?vue&type=template&id=4a0f29bc"
import script from "./PlanC.vue?vue&type=script&lang=js"
export * from "./PlanC.vue?vue&type=script&lang=js"

import "./PlanC.vue?vue&type=style&index=0&id=4a0f29bc&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__